/* Footer accordion and newsletter behavior for the current theme. */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 767px)');

  function isMobileViewport() {
    return mq.matches || window.innerWidth <= 767;
  }

  function closeAllAccordions(root) {
    root.querySelectorAll('.footer-accordion-col').forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = item.querySelector('.footer-accordion-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function setAccordionMode(root, isMobile) {
    root.querySelectorAll('.footer-accordion-toggle').forEach(function (btn) {
      if (!isMobile) {
        var col = btn.closest('.footer-accordion-col');
        if (col) col.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('.footer-accordion-toggle').forEach(function (btn) {
      if (btn.dataset.footerBound === 'true') return;
      btn.dataset.footerBound = 'true';

      btn.addEventListener('click', function () {
        if (!isMobileViewport()) return;

        var col = btn.closest('.footer-accordion-col');
        if (!col) return;

        var isOpen = col.classList.contains('is-open');
        closeAllAccordions(root);

        if (!isOpen) {
          col.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function bindNewsletter(root) {
    var form = root.querySelector('#ContactFooter');
    if (!form || form.dataset.footerBound === 'true') return;
    form.dataset.footerBound = 'true';

    var input = form.querySelector('input[type="email"]');
    var error = form.querySelector('.kv-footer__form-error');
    var success = root.querySelector('.kv-footer__form-success');
    var button = form.querySelector('.kv-footer__newsletter-button');

    if (!input) return;

    input.addEventListener('input', function () {
      input.classList.remove('field--error');
      if (error) {
        error.hidden = true;
        error.textContent = 'Please enter a valid email address.';
      }
    });

    form.addEventListener('submit', function (event) {
      var email = input.value.trim();
      var isValid = email && email.indexOf('@') > 0 && email.indexOf('.') > email.indexOf('@') + 1;

      if (!isValid) {
        event.preventDefault();
        input.classList.add('field--error');
        if (error) {
          error.hidden = false;
          error.textContent = 'Please enter a valid email address.';
        }
        input.focus();
        return;
      }

      event.preventDefault();
      if (button) button.disabled = true;

      var formData = new FormData(form);
      var action = form.getAttribute('action') || '/contact#ContactFooter';
      var endpoint = action.split('#')[0];

      fetch(endpoint, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');

          form.hidden = true;
          if (success) success.hidden = false;
        })
        .catch(function () {
          if (button) button.disabled = false;
          if (error) {
            error.hidden = false;
            error.textContent = 'Something went wrong. Please try again.';
          }
        });
    });
  }

  function initFooter(root) {
    initAccordions(root);
    setAccordionMode(root, isMobileViewport());
    bindNewsletter(root);
  }

  function initAllFooters() {
    document.querySelectorAll('.kv-footer').forEach(function (root) {
      initFooter(root);
    });
  }

  function handleViewportChange(event) {
    document.querySelectorAll('.kv-footer').forEach(function (root) {
      setAccordionMode(root, event.matches);
    });
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', handleViewportChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(handleViewportChange);
  }

  document.addEventListener('shopify:section:load', initAllFooters);
  initAllFooters();
})();
